module.exports = __webpack_public_path__ + "img/seabourn-logo.7f1d24cc.png";